import request from '@/utils/request'
const BASE_URL = '/EquipmentShiftWorkhours'

// 设备班次工时查询API
export default {
  // 获取列表（带汇总）
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  // 获取单条信息
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  // 保存
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  // 导出Excel
  export(data) {
    return request({
      url: BASE_URL + '/Export',
      method: 'post',
      data,
      responseType: 'blob'
    })
  },
  // 手动触发统计（测试用）
  calculate() {
    return request({
      url: BASE_URL + '/Calculate',
      method: 'post'
    })
  }
}
